import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GetAppModal from "../modal/GetAppModal";

const Header = () => {
  const [modalShow, setModalShow] = useState(false);

  const navigate = useNavigate();
  const handleRedirect = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const handleNavbarSelect = () => {
    document.getElementById("basic-navbar-nav-toggle").click();
  };

  return (
    <>
      <header>
        <Navbar
          expand="lg"
          className="bg-header-light position-fixed top-0 start-0 end-0 z-2 shadow-sm"
        >
          <Container>
            <Navbar.Brand
              as={Link}
              to="/"
              className={`${useLocation().pathname === "/" && "active"}`}
            >
              <h1 className="text-default-color fw-bold bebas-neue-font mb-0">
              <img src="..\Move-logo-BG-transparent.png"  height={30} />
              {/* Move */}
              </h1>
            </Navbar.Brand>
            <Navbar.Toggle
              id="basic-navbar-nav-toggle"
              aria-controls="basic-navbar-nav"
            />
            <Navbar.Collapse
              id="basic-navbar-nav menu-3"
              className="menu menu-3"
            >
              <Nav
                className="ms-auto nav text-start gap-lg-4"
                onSelect={handleNavbarSelect}
              >
                <Nav.Link
                  as={Link}
                  to="/"
                  eventKey="1"
                  className={`fw-500 plus-jakarta-sans-font NavLink ${
                    useLocation().pathname === "/" && "active"
                  }`}
                  onClick={() => handleRedirect("/")}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  eventKey="2"
                  className={`fw-500 plus-jakarta-sans-font NavLink ${
                    useLocation().pathname === "/about-us" && "active"
                  }`}
                  onClick={() => handleRedirect("/")}
                >
                  About Us
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/events"
                  eventKey="3"
                  className={`fw-500 plus-jakarta-sans-font NavLink ${
                    useLocation().pathname === "/events" && "active"
                  }`}
                  onClick={() => handleRedirect("/")}
                >
                  Event
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  eventKey="4"
                  className={`fw-500 plus-jakarta-sans-font NavLink ${
                    useLocation().pathname === "/contact-us" && "active"
                  }`}
                  onClick={() => handleRedirect("/")}
                >
                  Contact
                </Nav.Link>
                <Nav.Link
                  // as={Link}
                  // to=""
                  eventKey="4"
                  className="btnNavLink px-3 fw-500 btn btn-getapp rounded-pill fw-bold plus-jakarta-sans-font"
                  onClick={() => setModalShow(true)}
                >
                  Get the app
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
      <GetAppModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default Header;
